import { Checkbox } from '@infotech-soe/erp-ui-kit';
import classNames from 'classnames';
import React from 'react';
import { createUseStyles } from 'react-jss';

import { CheckboxFormControlViewModel } from '../../../services/form/view-model/FormControlViewModel';

import { TFormControlConnectorProps } from './FormControlContainer';

interface Props extends Omit<
  TFormControlConnectorProps,
  'onChange' | 'onChanged' | 'onSubmit'
> {
  control: CheckboxFormControlViewModel;
  onChange: (value: boolean | null) => void;
  onChanged: (value: boolean | null) => void;
  onSubmit: (value: boolean | null) => void;
}

const useStyles = createUseStyles({
  checkboxControl: {
    padding: 4,
  },
  PadTop: {
    paddingTop: 18,
  },
});

const FormCheckboxControl: React.FC<Props> = ({
  areHintsShown,
  control,
  onChange,
  onChanged,
  onSubmit,
}) => {
  const classes = useStyles();

  return (
    <Checkbox
      allowNull={control.allowNull}
      className={classNames(classes.checkboxControl, {
        [classes.PadTop]: control.padTop,
      })}
      disabled={control.disabled}
      {...(areHintsShown && { hint: control.hint })}
      label={control.label}
      name={control.name}
      readOnly={control.readonly}
      value={control.value}
      onChange={onChange}
      onChanged={onChanged}
      onSubmit={onSubmit}
    />
  );
};

export default FormCheckboxControl;
